<template>
    <v-container fill-height class="text-center">
        <v-row align-content="center" justify="center">
            <v-col cols="auto">
                <v-card flat color="transparent" class="text-center pt-6 pb-10" width="600">
                    <v-card-title class="justify-center opacity-7">{{ title }}</v-card-title>
                    <v-card-text class="opacity-7">
                        <v-icon size="120">{{ icon }}</v-icon>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <div>
                            <v-btn outlined color="secondary" :href="documentationLink" target="_blank" class="ml-2">
                                <v-icon left>mdi-book-open-variant</v-icon>
                                documentation
                            </v-btn>
                            <v-btn v-if="isSpaceRested" outlined color="primary" @click="wakeSpace()" class="ml-2">
                                <v-icon left>mdi-bell-outline</v-icon>
                                Wake up
                            </v-btn>
                            <v-btn
                                v-if="isSpaceArchived"
                                outlined
                                color="primary"
                                :to="{
                                    name: 'instance-snapshots',
                                    params: { ...$route.params },
                                    query: $route.query
                                }"
                                class="ml-2">
                                <v-icon left>mdi-camera</v-icon>
                                Snapshots
                            </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { fetchTask } from '@/apis'
import { createBackendErrorHandler } from '@/utils/errorMessages'
import * as lifecycleErrors from '@/modules/snapshot/errors/lifecycle'
import * as permissionsErrors from '@/utils/errors/permissions'
import * as snapshotErrors from '@/modules/snapshot/errors/snapshots'
import * as spaceErrors from '@/modules/space/errors'

const { getBackendErrorMessage } = createBackendErrorHandler(lifecycleErrors, permissionsErrors, snapshotErrors, spaceErrors)

export default {
    name: 'RestedCard',
    components: {},
    props: {},
    data() {
        return {}
    },
    computed: {
        ...mapGetters('spaceStore', ['isSpaceArchived', 'isSpaceRested']),
        ...mapState('spaceStore', ['currentSpace']),
        title() {
            if (this.isSpaceArchived) {
                return `Space archived on ${this.$options.filters.dateTimeToHuman(this.currentSpace?.archival_timestamp)}`
            } else if (this.isSpaceRested) {
                return `Space resting since ${this.$options.filters.dateTimeToHuman(this.currentSpace?.rested_timestamp)}`
            } else {
                return ''
            }
        },
        icon() {
            if (this.isSpaceArchived) {
                return 'mdi-archive-outline'
            } else if (this.isSpaceRested) {
                return 'mdi-sleep'
            } else {
                return ''
            }
        },

        documentationLink() {
            if (this.isSpaceArchived) {
                return 'https://docs.nuvolos.com/how-to-guides/workflows-for-instructors/archiving-your-course'
            } else if (this.isSpaceRested) {
                return 'https://docs.nuvolos.com/administration/space-management/resting-spaces'
            } else {
                return ''
            }
        }
    },
    methods: {
        async wakeSpace() {
            try {
                const { data } = await this.$axios.post(`/spaces/${this.$route.params.sid}/wake`)
                this.$store.dispatch('spaceStore/fetchCurrentSpace')
                const taskResult = await fetchTask(data.tkid)
                if (taskResult instanceof Error) {
                    throw taskResult
                } else {
                    this.$store.dispatch('spaceStore/fetchCurrentSpace')
                }
            } catch (error) {
                this.$store.dispatch('spaceStore/fetchCurrentSpace')
                const snackBarText = getBackendErrorMessage(error, 'Failed to wake up space.')
                if (snackBarText) {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText,
                        snackBarTimeout: 5000,
                        snackBarIcon: 'error'
                    })
                }
            }
        }
    },
    mounted() {}
}
</script>

<style scoped></style>
